import BookingPreview from './BookingPreview';
export default BookingPreview;
